var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customScrollbar"},[(_vm.title)?_c('div',{staticClass:"overline",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_c('v-card',{class:_vm.CardClass,style:(_vm.cardStyle),attrs:{"id":_vm.cardId}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }